{
  "fr": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Recevoir une notification lorsque de nouveaux messages sont publiés.",
          "label": "Actualités"
        },
        "question": {
          "description": "Recevoir une notification si une question a été créée.",
          "label": "FAQ"
        }
      },
      "employees": {
        "announcement": {
          "description": "Recevoir une notification lorsque de nouveaux messages sont publiés.",
          "label": "Actualités"
        },
        "decision": {
          "description": "Recevoir toutes les notifications liées aux décisions.",
          "label": "Décisions"
        },
        "document": {
          "description": "Recevoir une notification si quelqu'un télécharge un document.",
          "label": "Documents"
        },
        "export": {
          "description": "Recevoir une notification lorsque les exportations sont générées.",
          "label": "Exports"
        },
        "question": {
          "description": "Recevoir une notification si une question a été créée.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Recevoir toutes les notifications liées aux formulaires.",
          "label": "Formulaires"
        },
        "ticket": {
          "description": "Recevoir toutes les notifications liées aux conversations.",
          "label": "Conversations"
        },
        "todo": {
          "description": "Recevoir une notification si une tâche a été assignée.",
          "label": "Tâches assignées"
        }
      },
      "labels": {
        "email_preferences": "Préférences Email",
        "general_preferences": "Mes Préférences de Notification",
        "receiveEmailNotificationsAbout": "Recevoir des notifications par e-mail"
      }
    }
  }
}